import { Prop, Component, Vue } from 'vue-property-decorator';
import { normalizeComponent } from 'vue-runtime-helpers';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({ default: 'experience' })
    ], default_1.prototype, "iconName", void 0);
    __decorate([
        Prop({ default: '1em' })
    ], default_1.prototype, "width", void 0);
    __decorate([
        Prop({ default: '1em' })
    ], default_1.prototype, "height", void 0);
    __decorate([
        Prop({ default: 'currentColor' })
    ], default_1.prototype, "iconColor", void 0);
    default_1 = __decorate([
        Component
    ], default_1);
    return default_1;
}(Vue));

/* script */
const __vue_script__ = default_1;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 512 512",
        "aria-labelledby": _vm.iconName,
        role: "presentation"
      }
    },
    [
      _c("g", { attrs: { fill: _vm.iconColor } }, [
        _c("path", {
          attrs: {
            d:
              "m406.027344.0546875-32.605469 69.2539065-40.394531 6.023437-41.738282-6.066406-33.125-69.265625-33.121093 69.265625-41.765625 6.070313-41.765625-6.070313-33.121094-69.265625-33.113281 69.242188-75.277344 10.730468 54.988281 52.203125-12.503906 74.300781 65.90625-34.648437 65.902344 34.648437-12.519531-74.425781 21.503906-20.960937 21.503906 20.960937-12.523438 74.425781 65.90625-34.648437 65.902344 34.648437-12.519531-74.425781 21.371094-20.832031 20.730469 20.738281-12.273438 74.851563 64.675781-34.894532 64.90625 34.789063-12.238281-74.652344 53.09375-52.070312-73.191406-10.699219zm-271.300782 151.7773435-26.335937-13.84375-26.335937 13.84375 5.117187-30.40625-21.636719-20.535156 29.847656-4.253906 13.007813-27.203125 12.996094 27.179687 29.441406 4.277344-21.199219 20.660156zm149.773438 0-26.335938-13.84375-26.335937 13.84375 5.097656-30.28125-21.199219-20.660156 29.441407-4.277344 12.996093-27.179687 12.996094 27.179687 29.441406 4.277344-21.195312 20.660156zm147.074219-.226562-25.570313-13.703125-25.203125 13.597656 4.894531-29.855469-20.777343-20.78125 28.777343-4.292969 12.332032-26.195312 12.34375 26.222656 29.347656 4.285156-21.074219 20.667969zm0 0"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "m316.015625 302.316406c0-33.035156-26.875-59.910156-59.910156-59.910156-33.035157 0-59.910157 26.875-59.910157 59.910156 0 33.03125 26.875 59.910156 59.910157 59.910156 33.035156 0 59.910156-26.878906 59.910156-59.910156zm-59.910156 29.953125c-16.519531 0-29.957031-13.4375-29.957031-29.953125 0-16.519531 13.4375-29.957031 29.957031-29.957031 16.515625 0 29.953125 13.4375 29.953125 29.957031 0 16.515625-13.4375 29.953125-29.953125 29.953125zm0 0"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "m166.238281 332.269531c0-33.035156-26.875-59.910156-59.910156-59.910156s-59.910156 26.875-59.910156 59.910156c0 33.035157 26.875 59.910157 59.910156 59.910157s59.910156-26.875 59.910156-59.910157zm-59.910156 29.957031c-16.515625 0-29.953125-13.4375-29.953125-29.957031 0-16.515625 13.4375-29.953125 29.953125-29.953125 16.519531 0 29.957031 13.4375 29.957031 29.953125 0 16.519531-13.4375 29.957031-29.957031 29.957031zm0 0"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "m465.789062 332.269531c0-33.035156-26.875-59.910156-59.910156-59.910156s-59.910156 26.875-59.910156 59.910156c0 33.035157 26.875 59.910157 59.910156 59.910157s59.910156-26.875 59.910156-59.910157zm-59.910156 29.957031c-16.515625 0-29.953125-13.4375-29.953125-29.957031 0-16.515625 13.4375-29.953125 29.953125-29.953125 16.519532 0 29.957032 13.4375 29.957032 29.953125 0 16.519531-13.4375 29.957031-29.957032 29.957031zm0 0"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "m405.878906 392.179688c-21.875 0-43.179687 6.945312-60.8125 19.472656-18.542968-29.65625-51.484375-49.425782-88.960937-49.425782-37.480469 0-70.421875 19.769532-88.960938 49.425782-17.636719-12.527344-38.941406-19.472656-60.816406-19.472656-58.359375 0-105.839844 47.03125-105.839844 104.84375v14.976562h511.230469v-14.976562c0-57.8125-47.476562-104.84375-105.839844-104.84375zm-373.910156 89.867187c7.050781-34.140625 37.714844-59.910156 74.359375-59.910156 18.066406 0 34.992187 6.28125 48.496094 17.820312-2.320313 8.652344-3.5625 17.738281-3.5625 27.109375v14.980469zm299.023438 0h-149.773438v-14.980469c0-41.292968 33.59375-74.886718 74.886719-74.886718s74.886719 33.59375 74.886719 74.886718zm29.953124 0v-14.980469c0-9.371094-1.242187-18.457031-3.558593-27.109375 13.503906-11.539062 30.429687-17.820312 48.492187-17.820312 36.648438 0 67.308594 25.769531 74.363282 59.910156zm0 0"
          }
        })
      ])
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
